export function genDropDownOptions(label, value, data) {
    const options = data.map((current) => {
        return {
          label: current[label],
          value: current[value],
        };
      });
      return options
}
